import { useText } from '../../texts'

export default function Table({
  headers,
  users,
  action,
  isAllowEdit,
  isAllowDelete,
}) {
  const t = useText()
  return (
    <div className="table">
      <div className="t-header">
        {headers.map((header, i) => (
          <div className="t-header__item" key={i}>
            {header}
          </div>
        ))}
      </div>
      <div className="t-body">
        {users.map((user) => (
          <div className="t-row" key={user.id}>
            <div className="t-row__item">
              {user.confirmed ? t('accepted') : t('invited')}
            </div>
            <div className="t-row__item">{user.firstName}</div>
            <div className="t-row__item">{user.patronymic}</div>
            <div className="t-row__item">{user.lastName}</div>
            <div className="t-row__item">{user.email}</div>
            <div className="t-row__item">{t(user.role.type)}</div>
            <div className="t-row__item">
              {isAllowEdit(user) && (
                <button
                  className="btn btn-secondary"
                  onClick={() => action('edit', user)}
                >
                  {t('edit')}
                </button>
              )}
              {isAllowDelete(user) && (
                <button
                  className="btn btn-secondary"
                  onClick={() => action('delete', user)}
                >
                  {t('remove')}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
